import { render } from "./index.vue?vue&type=template&id=dad5124e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=dad5124e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-dad5124e"

export default script